import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Shell from "@/components/Shell";
import Command from "@/pages/Command";
import CRM from "@/pages/CRM";
import Settings from "@/pages/Settings";
import Omvexis from "@/pages/Omvexis";
import Widget from "@/pages/Widget";
import Login from "@/pages/Login";
import { AuthProvider, useAuth } from "@/context/AuthContext";

const Protected = () => {
  const { user } = useAuth();
  if (user === null) return <div className="min-h-screen bg-[#1d0702] flex items-center justify-center hud-label" data-testid="auth-loading">Verifying…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return <Shell />;
};

function App() {
  return (
    <div className="App dark">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/widget" element={<Widget />} />
            <Route path="/login" element={<Login />} />
            <Route element={<Protected />}>
              <Route path="/" element={<Command />} />
              <Route path="/omvexis" element={<Omvexis />} />
              <Route path="/enquiries" element={<CRM />} />
              <Route path="/settings" element={<Settings />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </AuthProvider>
      <Toaster theme="dark" position="bottom-right" />
    </div>
  );
}

export default App;
